import React, { PropsWithChildren } from "react";
import {
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogContent,
  AlertDialogTrigger,
  AlertDialog,
} from "@/components/ui";
import { Trans, useTranslation } from "react-i18next";

export function SeatAlert({
  showAlert,
  children,
}: PropsWithChildren<{ showAlert: boolean }>) {
  const { t } = useTranslation();

  if (!showAlert) {
    return children;
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("teamManagement.seatAlert.limitReached")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans i18nKey="teamManagement.seatAlert.description">
              Your community has used all of its seats for officials. Contact
              your Director of Partner Success or email
              <a
                href="mailto:support@zeemee.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-primary underline"
              >
                support@zeemee.com
              </a>
              to learn how you can add more.
            </Trans>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("global.close")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
